import { Container } from 'reactstrap';
import NotificationsList from '../../../Component/Application/Notifications/NotificationsList';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import { useTranslation } from 'react-i18next';

const Notifications = () => {
  const { t } = useTranslation();

  return (
    <div className='page-body'>
      <Breadcrumbs mainTitle={t('Mis Notificaciones')} parent={t('Administración')} />
      <Container fluid>
        <NotificationsList />
      </Container>
    </div>
  );
};

export default Notifications;

